export const optionOwnerHasCustomWorkTimeAllowed = "OptionOwnerHasCustomWorkTimeAllowed";
export const optionOwnerHasHourbookingTypeSelectAllowed = "OptionOwnerHasHourbookingTypeSelectAllowed";
export const optionOwnerHasTransportEnabled = "OptionOwnerHasTransportEnabled";
export const optionOwnerHasTransportNotificationsEnabled = "OptionOwnerHasTransportNotificationsEnabled";
export const optionOwnerHasEasyOppTelematicsEnabled = "OptionOwnerHasEasyOppTelematicsEnabled";
export const OptionRoutesEnabled = "RoutesEnabled";
export const OptionWorkShiftPlanningEnabled = "WorkShiftPlanningEnabled";
export const optionWorkTimeBreakButtonInMobileEnabled = "OptionWorkTimeBreakButtonInMobileEnabled";
export const OptionWorkTimeDefaultTimeZoneEnabled = "WorkTimeDefaultTimezoneEnabled";
export const OptionWorkTimeDefaultTimeZone = "WorkTimeDefaultTimezone";
export const OptionPublishedWorkShiftNotificationsEnabled = "PublishedWorkShiftNotificationsEnabled";
export const OptionFormsEnabled = "OptionFormsEnabled";
